import React, { useEffect, useState } from "react";
import { Alert, List, Stack } from "@mui/material";
// @ts-ignore
import { graphql } from "babel-plugin-relay/macro";
import { useLazyLoadQuery } from "react-relay";
import { RunnersQuery } from "./__generated__/RunnersQuery.graphql";
import Runner from "./Runner";
import { useParams } from "react-router-dom";
import QueuedJob from "./QueuedJob";

const SLOW_FETCH_INTERVAL = 10_000;
const FAST_FETCH_INTERVAL = 1_000;

function Runners() {
  const [fetchInterval, setFetchInterval] = useState(SLOW_FETCH_INTERVAL);
  const [fetchKey, setFetchKey] = useState(0);

  useEffect(() => {
    const timeoutId = setInterval(() => {
      setFetchKey(fetchKey + 1);
    }, fetchInterval);
    return () => clearInterval(timeoutId);
  }, [fetchKey, fetchInterval]);
  const params = useParams();
  const data = useLazyLoadQuery<RunnersQuery>(
    graphql`
      query RunnersQuery($name: String!) {
        organization(name: $name) {
          runners {
            id
            status
            slots
            ...Runner_runner
          }
          queuedJobInfos {
            jobId
            ...QueuedJob_info
          }
        }
      }
    `,
    { name: params.organization ?? "" },
    {
      fetchKey: fetchKey,
      fetchPolicy: "store-and-network",
    },
  );

  if (!data.organization) {
    window.location.replace("/login/github");

    return;
  }

  // Count runners
  let idleRunners = 0;
  let activeRunners = 0;
  for (let runner of data.organization.runners) {
    if (runner.status === "IDLE") {
      idleRunners += runner.slots;
    } else {
      activeRunners += runner.slots;
    }
  }
  const totalRunners = idleRunners + activeRunners;

  let liveUpdatesNeeded =
    data.organization.queuedJobInfos.length > 0 || activeRunners > 0;
  if (fetchInterval === SLOW_FETCH_INTERVAL && liveUpdatesNeeded) {
    console.log("switching to fast updates");
    setFetchInterval(FAST_FETCH_INTERVAL);
  } else if (fetchInterval === FAST_FETCH_INTERVAL && !liveUpdatesNeeded) {
    console.log("switching to slow updates");
    setFetchInterval(SLOW_FETCH_INTERVAL);
  }

  let queuedJobsCard = !data.organization.queuedJobInfos.length ? null : (
    <>
      <Stack alignItems="center" gap={4}>
        <div></div>
        <Alert severity="warning" variant="outlined">
          There are {data.organization.queuedJobInfos.length} queued jobs...
        </Alert>
        <div></div>
      </Stack>
      <List dense={true}>
        {data.organization.queuedJobInfos.map((info) => (
          <QueuedJob key={info.jobId} info={info} />
        ))}
      </List>
    </>
  );

  return (
    <>
      <Stack alignItems="center" gap={4}>
        <Alert severity="success" variant="outlined">
          You have {totalRunners} {totalRunners === 1 ? "runner" : "runners"} (
          {idleRunners} idle).
        </Alert>
        <div></div>
      </Stack>
      <Stack>
        <List dense={true}>
          {data.organization.runners.map((runner) => (
            <Runner key={runner.id} runner={runner} />
          ))}
        </List>
        {queuedJobsCard}
      </Stack>
    </>
  );
}

export default Runners;
